import { makeStyles } from '@material-ui/core/styles';
import { themeCommon } from '../../theme'

const useStyles = makeStyles((theme) => ({
    rootBody: {
        padding: '0px 12px',
    },
    rootContain: {
        boxShadow: 'none',
        border: `1px solid ${themeCommon.borderGray}`,
        cursor: 'pointer',
        '&:hover': {
            background: themeCommon.hovercolor,
        }
    },
    rootContainRead: {
        background: themeCommon.bg_btn_Blue,
    },
    rootGroup: {
        color: themeCommon.lightBlue,
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize12px,
        },
    },
    rootTitle: {
        display: '-webkit-box',
        '-webkit-line-clamp': '2',
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize14px,
        },
    },
    textBold: {
        fontWeight: 700,
    },
    textGreen: {
        color: '#4DD091'
    }
}), {
    name: 'NofiticationHolderHeadContainer',
    index: 1,
})

export default useStyles